export default function buildAreas({ columnParams, rowParams, z }) {
    function generateName(index, params) {
        const {
            capitalization,
            initial,
            prefix,
            scheme,
            stepSize,
            suffix,
            zeroPad,
        } = params;

        const position = initial + index * stepSize;

        let label = "";

        if (scheme === "numeric") {
            label = String(position).padStart(zeroPad, "0");
        } else {
            let n = position + 1;
            let letter = "";
            while (n > 0) {
                n--;
                letter = String.fromCharCode(65 + (n % 26)) + letter;
                n = Math.floor(n / 26);
            }
            label =
                capitalization === "lowercase" ? letter.toLowerCase() : letter;
        }

        return prefix + label + suffix;
    }

    function generateNames(params) {
        const amount = Math.max(0, params.amount ?? 0);
        const names = Array.from({ length: amount }, (_, i) =>
            generateName(i, params),
        );
        return params.order === "Descending" ? [...names].reverse() : names;
    }

    const columnNames = generateNames(columnParams);
    const rowNames = generateNames(rowParams);

    const areas = {};

    for (let colIdx = 0; colIdx < columnParams.amount; colIdx++) {
        const columnKey = columnNames[colIdx];
        const colSkewOffset = colIdx * columnParams.skewness;

        for (let rowIdx = 0; rowIdx < rowParams.amount; rowIdx++) {
            const rowSkewOffset = rowIdx * rowParams.skewness;

            const xMin =
                columnParams.startOffset +
                columnParams.spacing / 2 +
                colIdx * (columnParams.size + columnParams.spacing) +
                rowSkewOffset;
            const yMin =
                rowParams.startOffset +
                rowParams.spacing / 2 +
                rowIdx * (rowParams.size + rowParams.spacing) +
                colSkewOffset;
            const xMax = xMin + columnParams.size;
            const yMax = yMin + rowParams.size;

            areas[columnKey] ??= {};
            areas[columnKey][rowNames[rowIdx]] = {
                min: { x: xMin, y: yMin },
                max: { x: xMax, y: yMax },
                z: z,
            };
        }
    }

    return areas;
}
